import { FC } from "react";

import { t } from "../../../origins";

import st from "./CourseProgress.module.scss";

type Props = {
  lessonsCount?: number,
  completedLessons?: number,
};

export const CourseProgress: FC<Props> = ({
  lessonsCount,
  completedLessons,
}) => {
  return (
    <div className={st.progress}>
      <label className={st.progress_label}>
        {
          t("courseProgress.summary", {
            completed: completedLessons,
            total: lessonsCount,
          })
        }
        <progress
          className={st.progress_bar}
          max={lessonsCount}
          value={completedLessons}
        />
      </label>
    </div>
  );
};
